module Meevo.Plugins.Employee {

    import LocationSearchCriteria = Meevo.Model.LocationSearchCriteria;
    "use strict";

    /**
    * Location Section of Employee 
    */
    export class SharedSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.SharedLocations> {

        newAddEmployeeLocation: Model.LocationListItem;

        verifyModel(): boolean {
            return Model.Guard.isSomething(this.model);
        }
      
        showAddEmployeeLocation(): boolean {
            
            return (this.verifyModel() &&  !(this.mode === Meevo.Model.MaintenanceFormState.Readonly) && this.model.isSharedEmployee);
        }

        // TODO: Uncomment for multi location
        addLocation(): void {
            if (Model.Guard.isNothing(this.newAddEmployeeLocation) || this.verifyModel() === false)
                return;

                var foundList = this.model.locations.filter(locListItem => (locListItem.id === this.newAddEmployeeLocation.id));
            var locationAlreadyAdded: boolean = (Model.Guard.isSomething(foundList) && foundList.length > 0);
                if (!locationAlreadyAdded) {
                      
                    this.model.locations.push({ id: this.newAddEmployeeLocation.id, displayName: this.newAddEmployeeLocation.storeName });
                }

                this.newAddEmployeeLocation = null;
            
        }

        removeLocation(index: number): void {
            this.model.locations.splice(index, 1);
        }


        private _locationSearchContext: LocationSearchCriteria=
        {
            businessTypeId: null,
            filterBySessionUser: true,
            excludeSelf: true
        };

        get locationSearchContext(): LocationSearchCriteria {
            return this._locationSearchContext;
        }

        toggleIsSharedEmployee(atLocationId:number, atLocationName: string): void {
            if (this.model.isSharedEmployee === true) {
                this.model.locations.push({ id: atLocationId, displayName: atLocationName});
           
            }

            return;
        }
  
        isHomeLocation(locationId: number): boolean {
            return this.verifyModel() && this.model.homeLocationId === locationId;
        }
        allowSetEmployeeShare(atLocationId:number): boolean {
            
            return ( this.verifyModel() && !(this.mode === Meevo.Model.MaintenanceFormState.Readonly) &&
                !this.model.isSharedEmployee &&
                (this.identityService.inCentralOfficeMode() && this.model.homeLocationId === atLocationId) &&
                this.model.isMultiLocationEmployee === false);
        }
    
    }
}